export default "__VITE_ASSET__bca75263__"